import _ from 'lodash';

export default function addRequiredWarehouseNote(resultOptions, warehouses) {
	let filteredOptions = [];
	_.each(resultOptions, option => {
		let newOption = {
			value: option.assignedWarehouse.id,
			label: `${option.assignedWarehouse.applicationTitle}${
				warehouses.split(',').includes(option.assignedWarehouse.applicationTitle) ? ' (required)' : ''
			}`,
			extra: option.assignedWarehouse,
		};
		filteredOptions.push(newOption);
	});
	return filteredOptions;
}
